import { LanguageEnum } from 'utils/constants';
import { useFetch } from 'utils/sdk';
import { IPrice } from 'utils/types';

export interface IUsePaymentMethodListParams {
  flight_ticket_proposal_id: number;
}

export interface IPaymentMethod {
  id: number;
  method: string;
  label: Record<LanguageEnum, string>;
  provider: string;
  applied_fees: IPrice[];
  total_proposal_prices: IPrice[];
  supported_currencies: string[];
}

export const usePaymentMethods = ({ flight_ticket_proposal_id }: IUsePaymentMethodListParams) => {
  return useFetch<IPaymentMethod[]>(`api/customer-facing/payment-methods/${flight_ticket_proposal_id}/`);
};
